import styled from "styled-components"

const Title = styled.h1`
  &::after {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`
const SubTitle = styled.h3`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
  & ~ li {
    color: ${(props) => props.theme.c_color_gradients.c_dark};
  }
`
const TaxoButton = styled.span`
  border: 1px solid ${(props) => props.theme.b_color_gradients.b_dark};
  background-color: transparent;
  &:hover {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  & > a {
    color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`
const StyledFooter = styled.div`
  color: ${(props) => props.theme.c_color_gradients.c_medium};
`

export { Title, SubTitle, TaxoButton, StyledFooter }
